import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./customer-reviews-section.module.css";
var ReviewSection = function(param) {
    var reviewData = param.reviewData, containerClass = param.containerClass, contentClass = param.contentClass;
    var title = reviewData.title;
    var body = renderWithResolver(reviewData.text);
    return /*#__PURE__*/ _jsxs("section", {
        className: containerClass,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: contentClass,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.body,
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("img", {
                className: styles.image,
                src: reviewData.image.filename,
                alt: reviewData.image.alt || ""
            })
        ]
    });
};
export var CustomerReviewsSection = function(param) {
    var howCinchWorks = param.howCinchWorks, faffFreeMotoring = param.faffFreeMotoring;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ReviewSection, {
                reviewData: howCinchWorks,
                containerClass: styles.howCinchWorksContainer,
                contentClass: styles.howCinchWorksContent
            }),
            /*#__PURE__*/ _jsx(ReviewSection, {
                reviewData: faffFreeMotoring,
                containerClass: styles.faffFreeMotoringContainer,
                contentClass: styles.faffFreeMotoringContent
            })
        ]
    });
};
